import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SidebarService } from '../../@core/services/signals/sidebar.services';
import { NAV_ITEMS } from '../../@core/constants/nav-items.constant';
import { MenuItem } from '../../@core/interfaces/menu-item.interface';
import { getMenuItemsByRole } from '../../@core/services/commonServices/sidebar.service';
import { Store } from '@ngrx/store';
import { getCurrentUser, getUserPermissions, getUserRole } from '../../@core/store/auth-state/auth.selectors';
import { combineLatest, map } from 'rxjs';



@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: [
    '../layouts.component.scss',
    './sidebar.component.scss',
    './sidebar.component.responsive.scss',
  ],
})
export class SidebarComponent implements OnInit {
  profileImage: string | null = null; // Set to the image URL or null if no image
  selectedKey: any;
  userRole: string | null = null;
  navItems: MenuItem[] = NAV_ITEMS; 
  activeSubmenu: string | null = null;
 userPermissions: string[] = [];

  constructor(private readonly route: ActivatedRoute, private readonly store: Store) {
    this.route.queryParams.subscribe((params) => {
      this.selectedKey = params['key'];
    });
  }

  ngOnInit(): void {

    combineLatest([
    this.store.select(getUserRole).pipe(
      map(role => role?.toLowerCase() ?? null)
    ),
    this.store.select(getCurrentUser).pipe(
      map(user => user?.roles?.[0]?.origin_created_by?.toLowerCase() ?? null)
    ),
    this.store.select(getUserPermissions)
  ]).subscribe(([role, originCreatedBy, permissions]) => {

    this.userPermissions = permissions || [];

    const knownRoles = ['insuree', 'hmo', 'provider', 'payer', 'superadmin', 'nhia'];

    let resolvedRole: string | null = null;

    //  role already normalized to lowercase
    if (role && knownRoles.includes(role)) {
      resolvedRole = role;
    } 
    //  originCreatedBy also normalized
    else if (originCreatedBy && knownRoles.includes(originCreatedBy)) {
      resolvedRole = originCreatedBy;
    } 
    else {
      resolvedRole = null;
    }

    this.userRole = resolvedRole;

    if (resolvedRole) {
      this.navItems = getMenuItemsByRole(resolvedRole, this.userPermissions);
    }
  });

    // Subscribe to the store and get the user role
    // this.store.select(getUserRole).subscribe(role => {
    //   this.userRole = role;
    //   // Set the nav items based on the user role
    //   if (this.userRole) {
    //     this.navItems = getMenuItemsByRole(this.userRole, this.userPermissions);
    //   }
    // });

    // this.store.select(getUserPermissions).subscribe(permissions => {
    //   this.userPermissions = permissions || [];
    //    // Re-fetch menu items if permissions change
    //   if (this.userRole) {
    //     this.navItems = getMenuItemsByRole(this.userRole, this.userPermissions);
    //   }
    // });

    

  }

 private hasPermission(permissions: string[], key: string): boolean {
  return permissions.some(p => p === key || p === `${key}/view`);
} 

  isSubmenuActive(item: MenuItem): boolean {
    return this.activeSubmenu === item.name; // Check if the submenu is active
  }

  isActive(item: MenuItem, menuType?: string): boolean {
    if (menuType === 'submenu') {
      return window.location.pathname === item.link;
    } 
    else {
      return window.location.pathname === item.link ||  window.location.pathname.startsWith(item.link + '/');
    }
   
  }
  toggleMenu(item: MenuItem): void {
    const itemName = item.name;
    if (this.activeSubmenu === itemName) {
      // If the clicked submenu is already active, close it
      this.activeSubmenu = null;
    } else {
      // Open the new submenu and close the previous one
      this.activeSubmenu = itemName;
    }
  }

  sidebarService = inject(SidebarService);

  toggleSidebarIfMobile() {
    if (window.innerWidth <= 940) {
      this.sidebarService.toggle();
    }
  }

}
